module.exports = __webpack_public_path__ + "img/auth-corner.833c238f.png";